<div class="alert" [class]="data.type" [ngClass]="{'alert-error': data.closeButton, 'with-details': !!data.details?.length}">
    <mat-icon>{{ data.icon }}</mat-icon>
    <div class="text">
        <span>{{ data.message }}</span>
        @if (data.details?.length) {
            <ul class="details" data-testid="alert-message-details">
                @for (line of data.details; track $index) {
                    <li>{{ line }}</li>
                }
            </ul>
        }
    </div>
    @if (data.closeButton) {
        <mat-icon class="close" (click)="closeSnackbar()" data-testid="alert-message-close">close</mat-icon>
    }
</div>
